<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Новое сообщение',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
        return {
			title: 'Новое сообщение',
			items: [],
            trackBy: 'id',
            
            text: null,
            description: null,

            status: null,
            initStatus: [],
            status_options: [
                { id:'active',   name:'Активно' },
                { id:'disabled', name:'Отключено' },
            ],
		}
	},

    watch: {
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        }
    },

	computed: {
        item(){
            let account = this.$store.getters['botsMessages/GET_BOTS_MESSAGES_ITEM'];
            return account;
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            let user = session.user ? session.user : null;
            return user;
        },
        users_array_data(){
            return this.$store.getters['users/GET_USERS_ARRAY_DATA'];
        },
	},

	async mounted() {

        this.item_uuid = this.$route.params.uuid ? this.$route.params.uuid : '';

        if(this.item_uuid !== ''){

            this.title = 'Редактирование сообщения';
            document.title = 'Редактирование сообщения' + ' | ' + appConfig.title;

            let data_send = {
                'uuid' : this.item_uuid,
            }

            await this.$store.dispatch('botsMessages/FETCH_BOTS_MESSAGES_ITEM', data_send);

            this.text = this.item.text ? this.item.text : null;
            this.description = this.item.description ? this.item.description : null;
            this.status = this.item.status ? this.item.status : null;
            if (this.status !== null) {
                this.initStatus = [this.status];
            }
        }
	},

	methods: {

        async saveUser(){

            let data_send = {
                'text': this.text ? this.text : null,
                'description': this.description ? this.description : null,
                'status': this.status.id ? this.status.id : null,
            };

            let result = '';

            if(this.item_uuid === ''){
                result = await this.$store.dispatch('botsMessages/FETCH_BOTS_MESSAGES_CREATE', data_send);
            } else {
                data_send.uuid = this.item_uuid;
                result = await this.$store.dispatch('botsMessages/FETCH_BOTS_MESSAGES_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Bots.Messages'});
            }
        }
	}
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveUser"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <div class="row">
                            <div class="col">

                                <b-form-group
                                    label="Текст"
                                    label-for="text"
                                >
                                    <b-form-textarea
                                        id="text"
                                        v-model="text"
                                        placeholder=''
                                        rows="4"
                                    ></b-form-textarea>
                                </b-form-group>

                                <b-form-group
                                    label="Описание"
                                    label-for="description"
                                >
                                    <b-form-textarea
                                        id="description"
                                        v-model="description"
                                        placeholder=''
                                        rows="4"
                                    ></b-form-textarea>
                                </b-form-group>

                                <b-form-group
                                    label="Статус"
                                    label-for="status"
                                >
                                    <multiselect
                                        id="status"
                                        v-model="status"
                                        :options="status_options"
                                        placeholder="Выберите из списка"
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                        :track-by="trackBy"
                                    ></multiselect>
                                </b-form-group>

                            </div>
                        </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
    </Layout>
</template>
